<div class="flex h-full items-center justify-center">
  <div [auxTooltip]="params.invoiceLockTooltip() || 'Upload'">
    <button
      class="ml-1 flex h-7 w-7 items-center justify-center rounded-md bg-aux-blue p-0"
      type="button"
      data-pendo-id="invoice-files-upload"
      [disabled]="disabled()"
      (click)="onUploadClick()"
      [auxTooltip]="disabledTooltip()"
    >
      <aux-icon name="CloudUpload" class="text-white" [ngClass]="{ 'opacity-50': disabled() }" />
    </button>
  </div>
  @if (!params.hideDownloadButton) {
    <button
      class="ml-1 flex h-7 w-7 items-center justify-center rounded-md p-0"
      type="button"
      data-pendo-id="invoice-files-download"
      [auxTooltip]="'Download'"
      [ngClass]="{
        'bg-aux-green': fileExist,
        'bg-aux-gray-dark': !fileExist,
      }"
      [disabled]="params.disableDownloadButton || !fileExist"
      (click)="onDownloadClick()"
    >
      <aux-icon
        name="Download"
        class="stroke-[1.4px]"
        [ngClass]="{
          'text-white': fileExist,
          'text-aux-gray-darkest': !fileExist,
          'opacity-50': !fileExist,
        }"
      />
    </button>
  }

  <button
    class="mx-1 flex h-7 w-7 items-center justify-center rounded-md p-0"
    type="button"
    data-pendo-id="invoice-files-download-lines"
    [auxTooltip]="enableCSV ? 'Download Line Item Details' : ''"
    [ngClass]="{
      'bg-aux-green': enableCSV,
      'bg-aux-gray-dark': !enableCSV,
    }"
    [disabled]="!enableCSV"
    (click)="onDownloadLinesClick()"
  >
    <aux-icon
      name="FileTypeCsv"
      [ngClass]="{
        'text-white': enableCSV,
        'text-aux-gray-darkest': !enableCSV,
        'opacity-50': !enableCSV,
      }"
    />
  </button>
</div>
